import React from 'react';
import styles from './Sponsorship.module.scss';
import { useIntl } from 'react-intl';
import { Badge } from '@eventbrite/legacy-eds.badge';

export const Sponsorship = () => {
    const { formatMessage } = useIntl();
    return (
        <div>
            <span>{formatMessage({ id: 'Sponsorships', defaultMessage: 'Sponsorships' })}</span>
            <span className={styles.containerSpacing}>
                <Badge
                    text={formatMessage({ id: 'Beta', defaultMessage: 'Beta' })}
                    bgColor="ui-600"
                />
            </span>
        </div>
    );
};
